import * as React from 'react'

import { Meta } from '~/components'
import CoverageScreen from '~/screens/coverage'
import { getMetaInfo } from '~/utils'
import type { GetMetaInfoResult } from '~/utils/get-meta-info'

interface CoveragePageProps {
  metaInfo: GetMetaInfoResult
}

function CoveragePage(props: CoveragePageProps) {
  const { metaInfo } = props

  return (
    <>
      <Meta {...metaInfo} title="Cobertura" />
      <CoverageScreen />
    </>
  )
}

CoveragePage.getInitialProps = (context: PageContext): CoveragePageProps => {
  return { metaInfo: getMetaInfo(context) }
}

export default CoveragePage
